import { render } from "./StyleguideTableFilterTop.pug?vue&type=template&id=547a15af&lang=pug"
import script from "./StyleguideTableFilterTop.js?vue&type=script&lang=js"
export * from "./StyleguideTableFilterTop.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__